import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayers16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLayers16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.285 5.409 8.01 3.25 3.735 5.409 8.01 7.568zM8.46 2.357a1 1 0 0 0-.901 0L2.4 4.963a.5.5 0 0 0 0 .892L7.56 8.46a1 1 0 0 0 .901 0l5.16-2.605a.5.5 0 0 0 0-.892zm-6.407 5.35a.5.5 0 0 1 .67-.224l5.287 2.643 5.286-2.643a.5.5 0 0 1 .447.894l-5.51 2.755-.223.112-.224-.112-5.51-2.755a.5.5 0 0 1-.223-.67m.67 2.246a.5.5 0 1 0-.446.895l5.51 2.755.223.111.223-.111 5.51-2.755a.5.5 0 0 0-.447-.895L8.01 12.596z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayers16);
